import React from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGE_OPTIONS, getSelectedLanguage } from '../../utils/languages';

const LanguageSelector = ({ className = 'mt-5', showLabel = true, onLanguageChange }) => {
  const { t, i18n } = useTranslation();
  const label = t('auth.language');
  const selectedLanguage = getSelectedLanguage(i18n.language);

  return (
    <div className={`${className} font-semibold text-slate-900`}>
      <span className={showLabel ? 'block' : 'sr-only'}>{label}</span>
      <div
        role="group"
        aria-label={label}
        className={`${showLabel ? 'mt-2' : ''} inline-flex items-center gap-1 rounded-xl border border-slate-400 bg-white/5 p-1 shadow-sm`}
      >
        {LANGUAGE_OPTIONS.map((language) => {
          const selected = selectedLanguage === language.code;

          return (
            <button
              key={language.code}
              type="button"
              className={`
                h-11 w-12 text-xl
                inline-flex items-center justify-center
                rounded-lg leading-none
                transition
                focus:outline-none focus:ring-2 focus:ring-sky-200
                ${selected
                  ? 'bg-white/15 backdrop-blur-sm text-sky-600 shadow-sm ring-1 ring-sky-200/50'
                  : 'text-slate-700 hover:bg-white/20 hover:backdrop-blur-sm hover:text-sky-600'
                }
              `}
              aria-label={language.accessibilityLabel}
              aria-pressed={selected}
              title={language.accessibilityLabel}
              onClick={() => {
                onLanguageChange?.(language.code);
                i18n.changeLanguage(language.code);
              }}
            >
              <span aria-hidden="true">{language.flag}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LanguageSelector;
